const initialValue = (state = {}, action) => {
  switch (action.type) {
    case 'INIT_VALUE':
      return {
        data: action.data
      }

    default:
      return state
  }
}

export default initialValue;



// WEBPACK FOOTER //
// ./src/helpers/form/reducers/sppbFormReducer.js